var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "twitter-navigation" }, [
    _c("div", { staticClass: "twitter-navigation__wrapper" }, [
      _c(
        "div",
        {
          staticClass:
            "twitter-navigation__zoom-icon twitter-navigation__zoom-icon--left"
        },
        [
          _c("InlineSvg", {
            attrs: { src: "/images/cropper/ic-zoom-minus.svg" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "line",
          staticClass: "twitter-navigation__line-wrapper",
          on: { mousedown: _vm.onStart, touchstart: _vm.onStart }
        },
        [
          _c("div", { staticClass: "twitter-navigation__line" }, [
            _c("div", {
              staticClass: "twitter-navigation__fill",
              style: {
                flexGrow: _vm.zoom
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "twitter-navigation__circle",
                class: { "twitter-navigation__circle--focus": _vm.focus },
                style: {
                  left: `${_vm.zoom * 100}%`
                }
              },
              [
                _c("div", {
                  staticClass: "twitter-navigation__inner-circle",
                  class: {
                    "twitter-navigation__inner-circle--focus": _vm.focus
                  }
                })
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "twitter-navigation__zoom-icon twitter-navigation__zoom-icon--right"
        },
        [
          _c("InlineSvg", {
            attrs: { src: "/images/cropper/ic-zoom-plus.svg" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }